import {
  SET_ERROR,
  SET_DATA,
  UPDATE_COMPANY,
  UPDATE_MERCHANT,
  UPDATE_PARENT_COMPANY,
  SET_PROXY_USER,
  SET_ORDER_DISPLAY_TOKEN,
  SET_FEATURE_FLAGS,
  SET_USER_META,
  SET_CORPA_IMPERSONATION,
} from 'constants/auth';
import { IS_CORPA_IMPERSONATION } from 'constants/cuboh';

export const DEFAULT_STATE = {
  hasError: null,
  cubohUser: null,
  orderDisplayToken: null,
  companies: {},
  merchants: {},
  parentCompany: {},
  proxyUserID: null,
  isCorpaImpersonation: false,
  featureFlags: null,
  source: null,
};

// use localStorage to persist impersonation banner during page refresh
export const initializeCorpaImpersonation = initialState => ({
  ...initialState,
  isCorpaImpersonation: window.localStorage.getItem(IS_CORPA_IMPERSONATION) === 'true',
});

export const reducer = (state, action) => {
  switch (action.type) {
    case SET_ERROR:
      return { ...state, hasError: action.hasError, message: action.message };
    case SET_DATA:
      return { ...state, ...action.data };
    case SET_ORDER_DISPLAY_TOKEN:
      return { ...state, orderDisplayToken: action.orderDisplayToken };
    case UPDATE_COMPANY:
      return {
        ...state,
        companies: {
          ...state.companies,
          [action.id]: {
            ...state.companies[action.id],
            ...action.payload,
          },
        },
      };
    case UPDATE_MERCHANT:
      return {
        ...state,
        merchants: {
          ...state.merchants,
          [action.id]: {
            ...state.merchants[action.id],
            ...action.payload,
          },
        },
      };
    case UPDATE_PARENT_COMPANY:
      return {
        ...state,
        parentCompany: {
          ...state.parentCompany,
          ...action.parentCompany,
        },
      };
    case SET_PROXY_USER:
      return {
        ...state,
        proxyUserID: action.proxyUserID,
      };
    case SET_USER_META:
      return {
        ...state,
        cubohUser: {
          ...state.cubohUser,
          userDetails: {
            ...state.userDetails,
            userMeta: {
              ...action.userMeta,
            },
          },
        },
      };
    case SET_CORPA_IMPERSONATION:
      return {
        ...state,
        isCorpaImpersonation: action.isCorpaImpersonation,
      };
    case SET_FEATURE_FLAGS:
      return {
        ...state,
        featureFlags: action.featureFlags,
      };
    default:
      return { ...state };
  }
};
